import { z } from 'zod';
export const DateTimeSchema = z.iso.datetime();
//# sourceMappingURL=DateTimeSchemas.js.map